import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Alert, Paper } from "@mui/material";
import AppealSelectColumnHeaders from "./appealsSelectColumnHeaders/AppealSelectColumnHeaders";
import IDRTrackersSelectColumnHeaders from "./idrTrackersSelectColumnHeaders/IDRTrackersSelectColumnHeaders";
import PaidClaimsSelectColumnHeaders from "./paidClaimsSelectColumnHeaders/PaidClaimsSelectColumnHeaders";
import { SettingsModalProps } from "../../../../@types/appealReportAllprops.types";

const SettingsModal: React.FC<SettingsModalProps> = ({
	open,
	onClose,
	selectedColumns,
	handleUpdateSelectedColumns,
	claimsNameArray,
	appealsIDRTrackersCommonUnion,
	handleAppealsIDRTrackersCommonUnionChange
}) => {
	const renderClaimHeaders = () => {
		return claimsNameArray.map((claimType: string) => {
			const HeaderComponent =
				claimType === "paidclaims"
					? PaidClaimsSelectColumnHeaders
					: claimType === "appeals"
					? AppealSelectColumnHeaders
					: IDRTrackersSelectColumnHeaders;

			return (
				<HeaderComponent
					key={claimType}
					selectedColumns={selectedColumns}
					handleUpdateSelectedColumns={handleUpdateSelectedColumns}
					appealsIDRTrackersCommonUnion={appealsIDRTrackersCommonUnion}
					handleAppealsIDRTrackersCommonUnionChange={handleAppealsIDRTrackersCommonUnionChange}
				/>
			);
		});
	};

	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
			<DialogTitle>
				<h4
					style={{
						color: "#ab455c",
						textAlign: "center",
						marginBottom: "0.2rem"
					}}
				>
					Choose Column Headers for Reports
				</h4>
			</DialogTitle>
			<DialogContent>
				<Alert
					severity="warning"
					sx={{
						fontSize: "1rem",
						margin: "auto",
						marginTop: "10px",
						marginBottom: "10px",
						textAlign: "center",
						width: "fit-content"
					}}
					className="disclaimer-container"
				>
					<strong className="disclaimer">Disclaimer:</strong> Unchecking a field will exclude that column in
					the Excel Report.
				</Alert>
				<Paper elevation={3} style={{ borderRadius: "15px", padding: "2rem" }}>
					{renderClaimHeaders()}
				</Paper>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} variant="contained" style={{ backgroundColor: "#ab455c" }}>
					OK
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default SettingsModal;
